import {
  Grid,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FIRST_FINANCIAL_FIELDS } from "./allFields";
import FormField from "../../../../components/common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getAllInvoiceListAction } from "../../../../store/reducers/invoiceSlice";
interface FilterOption {
  search: string;
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  customerId?: string;
  customer_email?: string;
  telephone?: string;
  startDate?: string;
  endDate?: string;
  invoiceType?: string;
  invoiceNumber?: string;
  onlyOutstanding: boolean;
  onlySynced: boolean;
}
const FirstTabSection = ({
  formData,
  setFormData,
  setIsChanged,
  isRegNo,
  setIsRegNo,
  error,
  checkValidator,
}: any) => {
  const { userProfile } = useSelector((state: any) => state?.user);
  const { invoices } = useSelector((state: any) => state.invoice);
  const { newFinancialState } = useSelector((state: any) => state?.quickBook);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false
    );
  }, [userProfile]);

  const dispatch = useDispatch();

  const [filterOption, setFilterOption] = useState<FilterOption>({
    search: "",
    page: 1,
    limit: 1,
    orderBy: "created_at",
    orderIn: "DESC",
    customerId: "",
    customer_email: "",
    telephone: "",
    startDate: "",
    endDate: "",
    invoiceType: "",
    invoiceNumber: "",
    onlyOutstanding: false,
    onlySynced: false,
  });

  const getCleanFilter = () => {
    if (!isProfessionalSection) {
      // remove professional fields
      const {
        customerId,
        customer_email,
        telephone,
        startDate,
        endDate,
        invoiceType,
        invoiceNumber,
        onlyOutstanding,
        onlySynced,
        ...basicFilters
      } = filterOption;

      return basicFilters;
    }

    // send all filters when professional
    return filterOption;
  };

  useEffect(() => {
    dispatch(getAllInvoiceListAction(getCleanFilter()));
  }, [isProfessionalSection, dispatch]);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    setFormData((prev: any) => ({
      ...prev,
      [id]: value,
    }));
    setIsChanged(true);
  };

  const handleRadioChange = (e: any) => {
    const value = e.target.value === "yes";
    setIsRegNo(value);
    setIsChanged(true);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  return (
    <>
      <Grid
        item
        md={12}
        xs={12}
        sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
      >
        <Grid container spacing={2}>
          {FIRST_FINANCIAL_FIELDS.filter((field) => {
            // Hide certain fields if not Professional Section
            if (
              !isProfessionalSection &&
              [
                "is_deposit_required",
                "is_fca_registered",
                "invoice_due_days",
              ].includes(field.id)
            ) {
              return false;
            }

            // Hide VAT fields when Reg No = No
            if (
              !isRegNo &&
              (field.id === "vat_percent" || field.id === "vat_reg_no")
            ) {
              return false;
            }
            if(!formData?.is_fca_registered && field?.id ==='ipc_percent'){
              return false;
            }

            return true;
          }).map((field) => {
            // Special block for radio type
            if (field.type === "radio") {
              return (
                <Grid
                  key={field.id}
                  item
                  xs={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "18px !important",
                    paddingTop: "6px !important",
                  }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: "14px", mr: 2 }}>
                    {field.label}
                  </Typography>

                  <RadioGroup
                    row
                    value={isRegNo ? "yes" : "no"}
                    onChange={handleRadioChange}
                    sx={{ fontSize: "14px" }}
                    // aria-disabled={newFinancialState?.id ? true : false}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio size="small" />}
                      label="Yes"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px", // <-- label text size
                        },
                      }}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label="No"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px", // <-- label text size
                        },
                      }}
                    />
                  </RadioGroup>
                </Grid>
              );
            }

            return (
              <FormField
                key={field.id}
                onKeyDown={(event: any) => {
                  if (
                    [8, 9, 37, 38, 39, 40, 18, 17].includes(event.keyCode) ||
                    event.ctrlKey
                  ) {
                    return;
                  }

                  if (
                    field?.patternAllowed &&
                    !field.patternAllowed.test(event.key)
                  ) {
                    event.preventDefault();
                  } else if (
                    field?.patternAllowed &&
                    !field.patternAllowed.test(event.target.value + event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field,
                  value: formData[field.id] ?? "",
                  variant: "outlined",
                  checked:
                    field.type === "checkbox"
                      ? Boolean(formData[field.id])
                      : undefined,
                  minRows: 2,
                  isNonMarginTop: true,
                  inSingleGridForm: true,
                  disabled:
                    field?.id === "extended_liability_tax" ||
                    field?.id === "insurance_fixed_rate"
                      ? true
                      : field?.id === "invoice_serial_number" &&
                        invoices?.length > 0
                      ? true
                      : false,
                  onChange: onChangeAction,
                  onBlur: onBlurAction,
                  maxLength: 250,
                  options:
                    field?.options?.map((o: any) =>
                      typeof o === "object" ? o.value : o
                    ) || field.options,
                  InputProps: {
                    ...(field.inputProps || {}),
                    ...(field?.editReadOnly && {
                      disabled: field?.editReadOnly,
                    }),
                    sx:
                      field.type === "text" || field.type === "password"
                        ? { height: "36px" }
                        : { padding: "10px 4px", height: "36px" },
                  },
                  error: error && error[field.id],
                }}
              />
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default FirstTabSection;
